import {defineStore} from "pinia";
import api from "@/plugins/axios"

export const useDomainStore = defineStore('domains', {
    state: () => ({
        domains: [],
        domain: [],
        metrics: [],
    }),
    actions: {
        async getList(filters) {
            try {
                const {data} = await api.get(`domains`, {params: filters});
                this.domains = data;
                return this.domains
            } catch (error) {
                console.error(error);
            }
        },
        async getById(id) {
            try {
                const {data} = await api.get(`domains/${id}`);
                this.domain = data;
                return this.domain
            } catch (error) {
                console.error(error);
            }
        },
        async create(params) {
            try {
                const {data} = await api.post(`domains`, params);
                return data;
            } catch (error) {
                console.error(error);
            }
        },
        async getMetrics(filters) {
            try {
                const {data} = await api.get(`domains/metrics`, {params: filters});
                this.metrics = data;
                return this.metrics
            } catch (error) {
                console.error(error);
            }
        },
    }
})
